import { images } from "../../constants";

export const testimonials = [
  {
    imgurl: images.marina,
    feedback:
      "A diversified portfolio with a fresh design. I recommend Ionut's services.",
    name: "Marina",
    company: "Medicover",
  },
  {
    imgurl: images.stefania,
    feedback: "A great portfolio with great functionality.",
    name: "Stefania",
    company: "Zizi's Crafts",
  },
  {
    imgurl: images.sebi,
    feedback: "Ionut has great skills with React framework.",
    name: "Sebastian",
    company: "Vodafone",
  },
];


export const brands = [
  {
    _id: 1,
    imgUrl: images.asus,
    name: "Asus"
  },
  {
    _id: 2,
    imgUrl: images.spotify,
    name: "Spotify"
  },
  {
    _id: 3,
    imgUrl: images.amazon,
    name: "Amazon"
  },
  {
    _id: 4,
    imgUrl: images.skype,
    name: "Skype"
  },
  {
    _id: 5,
    imgUrl: images.bolt,
    name: "Bolt"
  },
]